import { cn } from "@/lib/utils";

export function PageShell({
    title,
    subtitle,
    right,
    children,
}: {
    title: string;
    subtitle?: string;
    right?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <div className="min-h-screen bg-bg">
            {/* Sticky glass HUD */}
            <div className="sticky top-0 z-40 bg-bg/80 backdrop-blur-xl border-b border-white/5">
                <div className="mx-auto max-w-lg px-4 py-4 flex items-center justify-between gap-4">
                    <div>
                        <div className="text-[10px] font-black uppercase tracking-widest text-text-muted">
                            PALAESTRA ACADEMY
                        </div>
                        <div className="text-white font-extrabold tracking-tight text-xl">
                            {title}
                        </div>
                        {subtitle ? (
                            <div className="text-text-secondary text-sm mt-1">{subtitle}</div>
                        ) : null}
                    </div>
                    {right ? <div className="shrink-0">{right}</div> : null}
                </div>
            </div>

            {/* Content lane */}
            <main className={cn("mx-auto max-w-lg px-4", "pt-5 pb-28")}>
                {children}
            </main>

            {/* dock lives below, so we reserve pb-28 */}
        </div>
    );
}
